module.exports = __webpack_public_path__ + "img/click_tab3.d88cac89.png";